import { useState, useContext, useEffect, useActionState } from "react";
import axios from "axios";
import CookieContext from "../contexts/CookieContext";
import AppContext from "../contexts/AppContext";
import { useForm } from "react-hook-form";
import styled from "@emotion/styled";

// import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
// import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';


import Guest from './Guest'

const StyledButton = styled.button`
  width: 200px;
  color: ${'lightgray'};
  background: ${({ disabled }) => disabled ? 'linear-gradient(180deg, #666666, #999999)' : 'linear-gradient(180deg, #100c08, #32dae6)'};
  ${({ disabled }) => disabled && `text-shadow: #cccccc 5px 5px 10px; box-shadow: #cccccc 5px 5px 10px;`};
`;

const WorkButton = styled.button`
  width: 200px;
  color: ${'lightgray'};
  background: ${({ disabled }) => disabled ? 'linear-gradient(180deg, #666666, #999999)' : 'linear-gradient(180deg, #100c08, #f59f3e)'};
  ${({ disabled }) => disabled && `text-shadow: #cccccc 5px 5px 10px; box-shadow: #cccccc 5px 5px 10px;`};
`;

const TimeTrackerButton = styled.button`
  width: 200px;
  color: ${'lightgray'};
  background: ${({ disabled }) => disabled ? 'linear-gradient(180deg, #666666, #999999)' : 'linear-gradient(180deg, #100c08, #b349ad)'};
  ${({ disabled }) => disabled && `text-shadow: #cccccc 5px 5px 10px; box-shadow: #cccccc 5px 5px 10px;`};
`;

const WorkTimeTracker = () => {
  const { apiUserHost, } = useContext(AppContext);
  const { cookies } = useContext(CookieContext);
  const { apiHost } = useContext(AppContext);
  const basePath = 'worktimetracker/';
  const [loading, setLoading] = useState(true);

  // const [disabled, setDisabled] = useState(true);
  const [updateDisabled, setUpdateDisabled] = useState(true);
  const [deleteDisabled, setDeleteDisabled] = useState(true);

  const [timeTrackerStartDisabled, setTimeTrackerStartDisabled] = useState(true);
  // const [timeTrackerStopDisabled, setTimeTrackerStopDisabled] = useState(false);

  const [refresh, setRefresh] = useState(false);
  const [error, setError] = useState();
  const [works, setWorks] = useState([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const [dataId, setDataId] = useState();
  const [dataName, setDataName] = useState();
  const [dataIpAddr, setDataIpAddr] = useState();
  const [dataUserId, setDataUserId] = useState();

  const [timeTrackerId, setTimeTrackerId] = useState();
  const [timeTrackers, setTimeTrackers] = useState([]);

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertId, setAlertId] = useState('');
  const [alertTitle, setAlertTitle] = useState('');
  const [alertMessage, setAlertMessage] = useState('');

  const handleAlertOpen = (id, title, message) => {
    setAlertId(id);
    setAlertTitle(title);
    setAlertMessage(message);
    setAlertOpen(true);
  }

  const handleAlertClose = () => {
    setAlertOpen(false);
  }

  // データ更新用
  useEffect(() => {
    fetchworks();
  }, [refresh]);

  const fetchworks = async () => {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${cookies.jwtAccess}`,
      };

      const response = await fetch(apiHost + basePath, {headers});

      if (response.status === 200) {
        const data = await response.json();
        setWorks(data);
      }
      else if (response.status === 401) {
        setError('ログインしてください');
      }
      else {
        setError('エラー');
      }
      setRefresh(true);
      setLoading(false);

  } catch (err) {
      console.log(err);
    }
  }

  const retrieveData = async(pk) => {
    try {
      if (cookies.jwtAccess) {
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        };

        const response = await fetch(`${apiHost}${basePath}${pk}/`, {headers});
        // fetch成功時、status200
        if (response.status === 200) {
          const data = await response.json();

          document.getElementById('name').value = data.name;

          setDataId(pk);
          setDataName(data.name);
          setDataIpAddr(data.ip_addr);
          setDataUserId(data.user);
          setUpdateDisabled(false);
          setDeleteDisabled(false);
          setTimeTrackerStartDisabled(false);
        } else if (response.status === 401) {
          setError('ログインしてください');
        } else {
          setError('エラー');
        }

        const response2 = await fetch(`${apiHost}${basePath}gettarget/${pk}/`, {headers});
        // fetch成功時、status200
        if (response2.status === 200) {
          const data = await response2.json();

          // setTimeTrackerId(data[0].id);
          // alert(data[0].id)
          setTimeTrackers(data);
        }

      } else {
        setError('認証エラー');
      }
    } catch (err) {
      console.log(err);
    }
  }

  const resetData = async() => {
    try {
      document.getElementById('name').value = '';
      setDataId('');
      setDataName('');
      setDataIpAddr('');
      setDataUserId('');
      setTimeTrackerId('');
      setTimeTrackers([]);

      setUpdateDisabled(true);
      setDeleteDisabled(true);
      setTimeTrackerStartDisabled(true);
    } catch (err) {
      console.log(err);
    }
  }

  const createData = async () => {
    // リフレッシュのための値を初期化
    setRefresh(false);
    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        var postData = {
          name: "新規",
          jwt_access: cookies.jwtAccess,
          access_token_username: cookies.accessTokenUsername,
          user: cookies.accessTokenUserId,
        }

        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        }

        const response = await axios.post(apiHost + basePath, postData, {headers});
        // post成功時、status201
        if (response.status === 201) {
          handleAlertOpen(response.data.id, 'データ追加', 'データ追加が完了しました');
          resetData();
        } else if (response.status === 401) {
          setError('ログインしてください');
        } else {
          setError('エラー');
        }
      } else {
        setError('認証エラー');
      }
    } catch (err) {
      console.log(err);
    }
  }

  const updateData = async (data) => {
    // リフレッシュのための値を初期化
    setRefresh(false);
    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        };

        const response = await axios.put(`${apiHost}${basePath}${dataId}/`, 
          {
            name: dataName,
          },
          {headers},
        )

        if (response.status === 200) {
          handleAlertOpen(response.data.id, 'データ更新', 'データ更新が完了しました');
          resetData();
        } else if (response.status === 401) {
          setError('ログインしてください');
        } else {
          setError('エラー');
        }
      } else {
        setError('認証エラー');
      }
    } catch (err) {
      console.log(err);
    }
  }

  const deleteData = async () => {
    // リフレッシュのための値を初期化
    setRefresh(false);
    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        }

        const response = await axios.delete(`${apiHost}${basePath}${dataId}/`, {headers})
        // delete成功時、status204
        if (response.status === 204) {
          handleAlertOpen(dataId, 'データ削除', 'データ削除が完了しました');
          resetData();
        } else if (response.status === 401){
          setError('ログインしてください');
        } else {
          setError('エラー');
        }
      } else {
        setError('認証エラー');
      }
    } catch (err) {
        console.log(err);
    };
  }
      
  const startTimeTracker = async () => {
    // リフレッシュのための値を初期化
    setRefresh(false);
    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        };

        const response = await axios.post(`${apiHost}${basePath}${dataId}/timetracker/`, 
          {
            // name: dataName,
          },
          {headers},
        )

        if (response.status === 201) {
          handleAlertOpen(response.data.id, 'スタート更新', 'スタート更新が完了しました');
          retrieveData(`${dataId}`);
        } else if (response.status === 401) {
          setError('ログインしてください');
        } else {
          setError('エラー');
        }
      } else {
        setError('認証エラー');
      }
    } catch (err) {
      console.log(err);
    }
  }

  const stopTimeTracker = async (pk) => {
    // リフレッシュのための値を初期化
    setRefresh(false);
    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        };

        const response = await axios.put(`${apiHost}${basePath}${dataId}/timetracker/${pk}/`, 
          {
            // name: dataName,
          },
          {headers},
        )

        if (response.status === 200) {
          handleAlertOpen(response.data.id, 'データ更新', 'データ更新が完了しました');
          retrieveData(`${dataId}`);
        } else if (response.status === 401) {
          setError('ログインしてください');
        } else {
          setError('エラー');
        }
      } else {
        setError('認証エラー');
      }
    } catch (err) {
      console.log(err);
    }
  }

  const reload = () => {
    window.location.reload();
  }

  if(loading) return <p>Loading...</p>;
  if(error) return <><p className="errMsg">Error: {error ? error : error.message}<a href="">[再読込]</a></p><StyledButton onClick={reload}>再読込</StyledButton></>;
  // if(error) return <><Guest /></>;

  return (
    <>
      <div><StyledButton onClick={createData}>データ追加</StyledButton></div>

        {/* 詳細エリア */}
        {Array.isArray(works)
          ? works.map((work, index) => {
            // return <RetrieveButton key={index} onClick={() => {retrieveData(kusuri.id)}}>user:{kusuri.user}:{kusuri.id}:{kusuri.name}</RetrieveButton>
            return <WorkButton key={index} onClick={() => {retrieveData(work.id)}}>【{work.id}】{work.name}</WorkButton>
          })
          : null
        }
        <br />
        dataId:{dataId}<br />
        dataName:{dataName}<br />
        dataIpAddr:{dataIpAddr}<br />
        dataUserId:{dataUserId}<br />

        <div className="bd-callout bd-callout-warning">
          <form>
            <label htmlFor="name">名前</label>
            <input id="name" disabled={updateDisabled} {
              ...register('name',
                {
                  onChange: (e) => setDataName(e.target.value)
                }
              )} />
            <p className="ErrMsg">{errors.name?.message}</p>
          </form>

        <div><WorkButton key={dataId} disabled={updateDisabled} onClick={updateData}>データ更新:{dataId}</WorkButton></div>
        <div><WorkButton key={dataId} disabled={deleteDisabled} onClick={deleteData}>データ削除:{dataId}</WorkButton></div>
        <Dialog
          open={alertOpen}
          onClose={handleAlertClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
        <DialogTitle id="alert-dialog-title">
          【{alertId}】{alertTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {alertMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <WorkButton onClick={handleAlertClose} autoFocus>OK</WorkButton>
        </DialogActions>
        </Dialog>
      </div>

      <div><TimeTrackerButton disabled={timeTrackerStartDisabled} onClick={startTimeTracker}>スタート:{dataId}</TimeTrackerButton></div>

      {/* <div><TimeTrackerButton disabled={timeTrackerStopDisabled} onClick={stopTimeTracker}>ストップ:{dataId}</TimeTrackerButton></div> */}

      {/* 詳細エリア */}
      {/* {Array.isArray(timeTrackers)
        ? timeTrackers.map((timeTracker, index) => {
          return (
            <TimeTrackerButton key={timeTracker.id} onClick={() => {startTimeTracker(timeTracker.id)}}>【{timeTracker.id}】スタート{timeTracker.beginning_time}</TimeTrackerButton>
          )
        })
        : null
      } */}
      {Array.isArray(timeTrackers)
        ? timeTrackers.map((timeTracker, index) => {
          return (
            <TimeTrackerButton key={timeTracker.id} onClick={() => {stopTimeTracker(timeTracker.id)}}>【{timeTracker.id}】ストップ{timeTracker.beginning_time}</TimeTrackerButton>
          )
        })
        : null
      }
    </>
  )
}
export default WorkTimeTracker
